import type { ReactElement } from 'react';

import { hr } from 'date-fns/locale';

import QuickActions from '../../components/QuickActions';
const items = [
  {
    text: 'Carteirinha Digital',
    icon: 'card.png',
    href: '/carteirinha',
  },
  {
    text: 'Demonstrativo Imposto de Renda',
    icon: 'list.png',
    href: '/ir',
  },
  {
    text: 'Rede Credenciada',
    icon: 'network.png',
    href: '/rede-credenciada',
  },
  {
    text: 'Cobertura do Plano',
    icon: 'insurance.png',
  },
  {
    text: 'Fale Conosco',
    icon: 'chat.png',
    href: '/faleconosco',
  },
];

const ActionsSection2 = (): ReactElement => (
  <section className="mt-10 mb-32">
    <QuickActions items={items} />
  </section>
);

export default ActionsSection2;
